/* eslint-disable @typescript-eslint/no-explicit-any */
import { useState } from 'react'
import { singletonHook } from 'react-singleton-hook'

const fetchUrl = () => {
  const url = window.location.href
  const lastSlashIndex = url.lastIndexOf('/')

  const result =
    lastSlashIndex !== -1 ? url.substring(0, lastSlashIndex + 1) : url
  const cleanedResult = result.replace(/\/$/, '')

  return cleanedResult
}

let markerProductData: any = null
let updateMarkerProductDataSubscribers = (value: any) => {
  const baseUrl = fetchUrl()
  markerProductData = {
    ...value,
    url: `${baseUrl}/${value?.seo?.productsSeoUrl}.html`
  }
}

export const getMarkerProductData = () => markerProductData

export const setMarkerProductData = (value: any) => {
  const baseUrl = fetchUrl()
  markerProductData = {
    ...value,
    url: `${baseUrl}/${value?.seo?.productsSeoUrl}.html`
  }
  updateMarkerProductDataSubscribers(markerProductData)
}

export const useInitMarkerProductData = singletonHook(
  getMarkerProductData,
  () => {
    const [productData, setProductData] = useState<any>(getMarkerProductData)
    updateMarkerProductDataSubscribers = setProductData
    return productData
  }
)
